/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
import buttonLikeRoles from './buttonLikeRoles';
import isDisabled from './isDisabled';
import propsToAccessibilityComponent from './propsToAccessibilityComponent';
import propsToAriaRole from './propsToAriaRole';
var AccessibilityUtil = {
  buttonLikeRoles: buttonLikeRoles,
  isDisabled: isDisabled,
  propsToAccessibilityComponent: propsToAccessibilityComponent,
  propsToAriaRole: propsToAriaRole
};
export default AccessibilityUtil;
